var render = function render(){var _vm=this,_c=_vm._self._c;return _c('round',{attrs:{"device":_vm.device}},[_c('div',[_c('img',{staticStyle:{"height":"65px"},attrs:{"src":_vm.icon}})]),_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{domProps:{"textContent":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }